module.exports = __webpack_public_path__ + "static/media/background-tao.24b5b93d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/lesson-path/img/background-tao.png
// module id = 701
// module chunks = 1